import * as React from "react";
import Header from "../components/header";
import Footer from "../components/footer";

const NotFoundPage = () => {
  return (
    <main style={{ backgroundColor: "#0a0a0a", minHeight: "100vh", color: "#fff" }}>
      <Header />
      <Footer />
    </main>
  );
};

export default NotFoundPage;